import Vue from 'vue'
import {getAccountCodeFromStorage, getAccountNameFromStorage, getPersonCodeFromStorage, getPersonNameFromStorage, getYqCodeFromStorage, getYqNameFromStorage, getTokenImmediately, getPermissionCodesFromStorage} from '../utils/storage'
import {getUpperDataFromStorage} from './storage'

const bus = {
  global: {
    personCode: '',
    personName: '',
    accountCode: '',
    accountName: '',
    yqCode: '',
    yqName: '',
    token: '',
    accountHasBuildingCode: '',
    permissionCodes: '',

    upperData: {
      accountName: '',
      accountCode: '',
      token: '',
      yqAppCodeList: [],
      groupAppCode: '',
    }
  },
  vue: new Vue()
}

export function getAccountCode () {
  if (!bus.global.accountCode) {
    bus.global.accountCode = getAccountCodeFromStorage()
  }
  return bus.global.accountCode
}

export function getAccountName () {
  if (!bus.global.accountName) {
    bus.global.accountName = getAccountNameFromStorage()
  }
  return bus.global.accountName
}

export function getPersonCode () {
  if (!bus.global.personCode) {
    bus.global.personCode = getPersonCodeFromStorage()
  }
  return bus.global.personCode
}

export function getPersonName () {
  if (!bus.global.personName) {
    bus.global.personName = getPersonNameFromStorage()
  }
  return bus.global.personName
}

export function getYqCode () {
  if (!bus.global.yqCode) {
    bus.global.yqCode = getYqCodeFromStorage()
  }
  return bus.global.yqCode
}

export function getYqName () {
  if (!bus.global.yqName) {
    bus.global.yqName = getYqNameFromStorage()
  }
  return bus.global.yqName
}

export function getToken () {
  if (!bus.global.token) {
    bus.global.token = getTokenImmediately()
  }
  return bus.global.yqCode
}

export function getPermissionCodes () {
  if (!bus.global.permissionCodes) {
    bus.global.permissionCodes = getPermissionCodesFromStorage()
  }
  return bus.global.permissionCodes
}

export function getUpperData () {
  if (!bus.global.upperData.groupAppCode || !bus.global.upperData.token) {
    bus.global.upperData = getUpperDataFromStorage()
  }
  return bus.global.upperData
}

export default bus
export {bus}



// WEBPACK FOOTER //
// ./src/utils/bus.js